const handleClick = function(data) {
  return function(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    document
      .querySelector(data.selector)
      .scrollIntoView({ behavior: "smooth", block: "start" });
  };
};

/*
 * Directive ScrollIntoView
 * Binds native scrollIntoView functionality to DOM elements.
 *
 * Usage:
 * v-scroll-into-view="String('body')"
 *
 * @params:
 *
 * value   - valid selector of a DOM node
 */
export const ScrollIntoView = {
  bind(el, binding, vnode) {
    const selector = binding.value || "body";

    // events for all elements
    el.addEventListener("click", handleClick({ vnode, selector }), false);
  },

  unbind(el) {
    // ToDo: Remove Events!!!
    el.removeEventListener("click", handleClick({}));
  }
};

// make directive available globally
// Vue.directive("scroll-into-view", ScrollIntoView);
